import _JSON$stringify from "/app/node_modules/babel-runtime/core-js/json/stringify";
import _objectDestructuringEmpty from "/app/node_modules/babel-runtime/helpers/objectDestructuringEmpty";
import _regeneratorRuntime from "/app/node_modules/babel-runtime/regenerator";
import _asyncToGenerator from "/app/node_modules/babel-runtime/helpers/asyncToGenerator";
import { mcciCommercialBusinessIds } from "~/constants";
import { responseToState, calculateUbigeo } from "~/mappers";
import { currencyTypeEnum } from "../enums";
import { MembershipApi, MasterApi } from "~/api";

export var state = function state() {
  return {
    masterData: null,
    bossList: [],

    //step 3
    documentTypes: [],

    //step 4
    conglomerateTypes: [],
    opNationalMcc: [],
    opCommercialBusiness: [],
    departments: [],
    provinces: [],
    districts: [],
    typeRoads: [],
    typeInteriors: [],
    names: [],

    //step 7
    coins: [],
    banks: [],
    accountTypes: [],
    productsType: [],
    products: [],
    development: [],
    platform: [],
    osvTypes: [],
    documentTypesCollaboratorsPage: [],
    userCategories: [],

    tariff: {},
    agents: [],
    affiliationTypes: []
  };
};

export var getters = {
  coins: function coins(state, getters, rootState, rootGetters) {
    console.log("=============Get Coins=============");
    var coins = [];
    var dato = rootState.affiliations.form.typeModalityTitle;
    var grifo = rootState.affiliations.form.mcciForGrifo;
    var productType = rootState.affiliations.form.posSelected.pos;
    console.log('commerceData', rootState.affiliations.form.businessData.commerceData);
    console.log('nationalMcc', rootState.affiliations.form.businessData.commerceData.nationalMcc);
    console.log('index of', mcciCommercialBusinessIds.indexOf(Number(rootState.affiliations.form.businessData.commerceData.nationalMcc)));
    if (rootState.affiliations.form.businessData.commerceData.nationalMcc && mcciCommercialBusinessIds.indexOf(Number(rootState.affiliations.form.businessData.commerceData.nationalMcc)) === -1 && (Number(rootState.affiliations.form.businessData.commerceData.nationalMcc) < 3000 || Number(rootState.affiliations.form.businessData.commerceData.nationalMcc) > 3999)) {
      console.log("Filtro Soles");
      coins = state.coins.filter(function (c) {
        return c.value === currencyTypeEnum.SOLES;
      });
    } else {
      coins = state.coins;
      //   if (
      //     // dato === "Venta Extendida" ||
      //     productType === "Pago Link" ||
      //     productType === "Pago Web" ||
      //     productType === "Pago App" ||
      //     grifo === "5541"
      //   ) {
      // 	console.log("Filtro Dolares y Soles")
      //     coins = coins.filter(c => c.value != "1-y-2");
      //   }
    }
    // if(grifo === '5541' ) coins.push('2')

    // if (rootGetters['affiliations/form/isVirtual']) coins = coins.filter(c => c.value !== currencyTypeEnum.SOLES_Y_DOLARES);
    //corresponsalia
    if (productType === "Corresponsalía") coins = coins.filter(function (c) {
      return c.value === currencyTypeEnum.SOLES;
    });

    console.log("master-data-coins ", coins);
    console.log("root-master-data-coins ", dato);
    return coins;
  },

  documentTypes: function documentTypes(state, getters, rootState, rootGetters) {
    var documentTypes = state.documentTypes;

    if (rootGetters["affiliations/form/isVirtual"]) documentTypes = documentTypes.filter(function (d) {
      return d.value !== "CEX";
    });

    // documentTypes = documentTypes.filter(d => d.Code !== 'RUC');

    return documentTypes;
  },
  documentTypesLegalRepresentative: function documentTypesLegalRepresentative(state, getters, rootState, rootGetters) {
    var documentTypes = state.documentTypes;

    if (rootGetters["affiliations/form/isVirtual"]) documentTypes = documentTypes.filter(function (d) {
      return d.value !== "CEX";
    });
    documentTypes = documentTypes.filter(function (d) {
      return d.Code !== "RUC";
    });

    return documentTypes;
  }
};

export var mutations = {
  setMasterData: function setMasterData(state, master) {
    state.masterData = master;
    state.productsType = responseToState(master.productsType, "IdProductType", "Description");
    //step 3
    state.documentTypes = master.documentTypes;

    //step 4
    state.opCommercialBusiness = master.opCommercialBusiness;
    state.departments = master.departments;
    state.typeRoads = master.typeRoads;
    state.typeInteriors = master.typeInteriors;
    state.names = master.names;

    //step7
    var coins = responseToState(master.coins, "IdCurrency", "Description");
    coins.forEach(function (c) {
      return c.value = String(c.value);
    });
    coins.push({
      value: currencyTypeEnum.SOLES_Y_DOLARES,
      text: "Soles y Dólares"
    });
    state.coins = coins;

    state.osvTypes = responseToState(master.osvTypes, "IdTypeOSV", "Name");

    state.banks = master.banks;
    state.accountTypes = responseToState(master.accountType, "accountTypeId", "accountTypeDescription");
    state.documentTypesCollaboratorsPage = responseToState(master.documentTypesCollaboratorsPage, "IdDocumentType", "Code");
    state.userCategories = responseToState(master.userCategories, "IdUserCategory", "Name");

    // Lista de jefes
    state.bossList = master.bossList;
  },
  setCommercialBusiness: function setCommercialBusiness(state, mcc) {
    state.opCommercialBusiness = mcc.result;
    state.opNationalMcc = mcc.result;
  },
  setProvinces: function setProvinces(state, provinces) {
    state.provinces = provinces;
  },
  setProducts: function setProducts(state, data) {
    state.products = data;
  },
  setDevelopment: function setDevelopment(state, data) {
    state.development = data;
  },
  setPlatform: function setPlatform(state, data) {
    state.platform = data;
  },
  setTariff: function setTariff(state, data) {
    state.tariff = data;
  },
  setAgent: function setAgent(state, data) {
    state.agents = data;
  }
};

export var actions = {
  initialLoad: function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch;
      var masterApi, results;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              masterApi = new MasterApi(this.$axios);
              _context.next = 3;
              return masterApi.findAllEndpointsInit();

            case 3:
              results = _context.sent;

              // console.log(results[2]);
              commit("setMasterData", {
                productsType: results[0],
                documentTypes: results[1],
                opCommercialBusiness: results[2],
                departments: results[3],
                typeRoads: results[4],
                typeInteriors: results[5],
                banks: results[6],
                coins: results[7],
                osvTypes: results[8],
                documentTypesCollaboratorsPage: results[9],
                userCategories: results[10],
                names: results[11],
                bossList: results[12]
              });

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function initialLoad(_x) {
      return _ref2.apply(this, arguments);
    }

    return initialLoad;
  }(),
  newTariff: function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3, data) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _objectDestructuringEmpty(_ref3);

              _context2.next = 3;
              return new MasterApi(this.$axios).newTariff({
                platform: data.platform,
                channel: data.channel,
                subproduct: data.subproduct,
                currency: data.currency,
                affiliation: data.affiliation,
                affiliationComment: data.affiliationComment,
                equipmentCost: data.equipmentCost,
                equipmentCostComment: data.equipmentCostComment,
                maintenance: data.maintenance,
                maintenanceDollar: data.maintenanceDollar,
                maintenanceComment: data.maintenanceComment,
                platformUsageCE: data.platformUsageCE,
                platformUsageCEComment: data.platformUsageCEComment,
                renewal: data.renewal,
                renewalComment: data.renewalComment
              });

            case 3:
              return _context2.abrupt("return", _context2.sent);

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function newTariff(_x2, _x3) {
      return _ref4.apply(this, arguments);
    }

    return newTariff;
  }(),
  updateTariff: function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref5, data) {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _objectDestructuringEmpty(_ref5);

              _context3.next = 3;
              return new MasterApi(this.$axios).updateTariff({
                platform: data.platform,
                channel: data.channel,
                subproduct: data.subproduct,
                currency: data.currency,
                affiliation: data.affiliation,
                affiliationComment: data.affiliationComment,
                equipmentCost: data.equipmentCost,
                equipmentCostComment: data.equipmentCostComment,
                maintenance: data.maintenance,
                maintenanceDollar: data.maintenanceDollar,
                maintenanceComment: data.maintenanceComment,
                platformUsageCE: data.platformUsageCE,
                platformUsageCEComment: data.platformUsageCEComment,
                renewal: data.renewal,
                renewalComment: data.renewalComment,
                idTariff: data.idTariff
              });

            case 3:
              return _context3.abrupt("return", _context3.sent);

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function updateTariff(_x4, _x5) {
      return _ref6.apply(this, arguments);
    }

    return updateTariff;
  }(),
  findTariff: function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref7, data) {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _objectDestructuringEmpty(_ref7);

              _context4.next = 3;
              return new MasterApi(this.$axios).findTariff({
                platform: data.platform,
                channel: data.channel,
                subproduct: data.subproduct,
                currency: data.currency
              });

            case 3:
              return _context4.abrupt("return", _context4.sent);

            case 4:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function findTariff(_x6, _x7) {
      return _ref8.apply(this, arguments);
    }

    return findTariff;
  }(),
  tariff: function () {
    var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref9, id) {
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _objectDestructuringEmpty(_ref9);

              _context5.next = 3;
              return new MasterApi(this.$axios).tariff(id);

            case 3:
              return _context5.abrupt("return", _context5.sent);

            case 4:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function tariff(_x8, _x9) {
      return _ref10.apply(this, arguments);
    }

    return tariff;
  }(),
  getTariff: function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return new MasterApi(this.$axios).getTariff();

            case 2:
              return _context6.abrupt("return", _context6.sent);

            case 3:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, this);
    }));

    function getTariff() {
      return _ref11.apply(this, arguments);
    }

    return getTariff;
  }(),
  getModelPosByNameProduct: function () {
    var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_ref12, data) {
      var response;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _objectDestructuringEmpty(_ref12);

              _context7.next = 3;
              return new MasterApi(this.$axios).findModelPosByProduct(data);

            case 3:
              response = _context7.sent;
              return _context7.abrupt("return", response);

            case 5:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, this);
    }));

    function getModelPosByNameProduct(_x10, _x11) {
      return _ref13.apply(this, arguments);
    }

    return getModelPosByNameProduct;
  }(),
  getProducts: function () {
    var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(_ref14) {
      var commit = _ref14.commit,
          dispatch = _ref14.dispatch;
      var tmpPresenciales, presenciales, virtuales;
      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return dispatch("findAllProductByType", 1);

            case 2:
              tmpPresenciales = _context8.sent;

              console.log(JSON.parse(_JSON$stringify(tmpPresenciales)));
              presenciales = [tmpPresenciales[2], tmpPresenciales[3], tmpPresenciales[4], tmpPresenciales[0], tmpPresenciales[1], tmpPresenciales[5]];
              _context8.next = 7;
              return dispatch("findAllProductByType", 2);

            case 7:
              virtuales = _context8.sent;

              commit("setProducts", presenciales.concat(virtuales));

            case 9:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, this);
    }));

    function getProducts(_x12) {
      return _ref15.apply(this, arguments);
    }

    return getProducts;
  }(),
  findAllProductByType: function () {
    var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(_ref16, data) {
      var response;
      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _objectDestructuringEmpty(_ref16);

              _context9.next = 3;
              return new MasterApi(this.$axios).findAllProductByType({
                idproducttype: data
              });

            case 3:
              response = _context9.sent;
              return _context9.abrupt("return", response);

            case 5:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, this);
    }));

    function findAllProductByType(_x13, _x14) {
      return _ref17.apply(this, arguments);
    }

    return findAllProductByType;
  }(),
  getCommercialBusiness: function () {
    var _ref19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(_ref18, ctx) {
      var dispatch = _ref18.dispatch,
          commit = _ref18.commit;
      return _regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.t0 = commit;
              _context10.next = 3;
              return new MembershipApi(this.$axios).getCommercialBusiness();

            case 3:
              _context10.t1 = _context10.sent;
              (0, _context10.t0)("setCommercialBusiness", _context10.t1);

            case 5:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, this);
    }));

    function getCommercialBusiness(_x15, _x16) {
      return _ref19.apply(this, arguments);
    }

    return getCommercialBusiness;
  }(),
  getProvince: function () {
    var _ref22 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(_ref20, _ref21) {
      var state = _ref20.state,
          commit = _ref20.commit;
      var departmentId = _ref21.departmentId;
      var response, provinces;
      return _regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return new MasterApi(this.$axios).findAllProvinceByDepartament({
                idDepartament: departmentId
              });

            case 2:
              response = _context11.sent;
              provinces = response;

              commit("setProvinces", provinces);
              return _context11.abrupt("return", provinces);

            case 6:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, this);
    }));

    function getProvince(_x17, _x18) {
      return _ref22.apply(this, arguments);
    }

    return getProvince;
  }(),
  getDistrict: function () {
    var _ref25 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(_ref23, _ref24) {
      var state = _ref23.state;
      var departmentId = _ref24.departmentId,
          provinceId = _ref24.provinceId;

      var response, _districts;

      return _regeneratorRuntime.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              if (!(provinceId !== "")) {
                _context12.next = 8;
                break;
              }

              _context12.next = 3;
              return new MasterApi(this.$axios).findAllDistrictByProvince({
                idDepartament: departmentId,
                idProvince: provinceId
              });

            case 3:
              response = _context12.sent;
              _districts = response;
              return _context12.abrupt("return", _districts || []);

            case 8:
              commit("setDistricts", districts);
              return _context12.abrupt("return", districts || []);

            case 10:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, this);
    }));

    function getDistrict(_x19, _x20) {
      return _ref25.apply(this, arguments);
    }

    return getDistrict;
  }(),
  findAllTypeAccountByBank: function findAllTypeAccountByBank(_ref26, data) {
    var state = _ref26.state;

    return new MasterApi(this.$axios).findAllTypeAccountByBank(data);
  },
  findAllTypeDevelopment: function () {
    var _ref28 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(_ref27) {
      var commit = _ref27.commit;
      var response;
      return _regeneratorRuntime.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              _context13.t0 = responseToState;
              _context13.next = 3;
              return new MasterApi(this.$axios).findAllTypeDevelopment();

            case 3:
              _context13.t1 = _context13.sent;
              response = (0, _context13.t0)(_context13.t1, "IdTypeOfDevelopment", "Name");

              commit("setDevelopment", response);

            case 6:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13, this);
    }));

    function findAllTypeDevelopment(_x21) {
      return _ref28.apply(this, arguments);
    }

    return findAllTypeDevelopment;
  }(),
  findAllPlatform: function () {
    var _ref30 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(_ref29) {
      var commit = _ref29.commit;
      var response;
      return _regeneratorRuntime.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              _context14.t0 = responseToState;
              _context14.next = 3;
              return new MasterApi(this.$axios).findAllPlatform();

            case 3:
              _context14.t1 = _context14.sent;
              response = (0, _context14.t0)(_context14.t1, "IdPlatform", "Name");

              commit("setPlatform", response);

            case 6:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14, this);
    }));

    function findAllPlatform(_x22) {
      return _ref30.apply(this, arguments);
    }

    return findAllPlatform;
  }(),
  findAllAgent: function () {
    var _ref32 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(_ref31) {
      var commit = _ref31.commit;
      var agents;
      return _regeneratorRuntime.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              _context15.next = 2;
              return new MasterApi(this.$axios).findAllAgent();

            case 2:
              agents = _context15.sent;

              commit('setAgent', agents);

            case 4:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15, this);
    }));

    function findAllAgent(_x23) {
      return _ref32.apply(this, arguments);
    }

    return findAllAgent;
  }()
};


//////////////////
// WEBPACK FOOTER
// ./src/store/master-data.js
// module id = ./src/store/master-data.js
// module chunks = 34